/**
 * A single falling leaf — used as a quiet decorative anchor at the top
 * of a page. Always amber, always 85% opacity. Positions vary by
 * `position` prop: 'left' (default) drops down on the left margin,
 * 'right' on the right. Hidden on small screens.
 */
export function CornerLeaf({
  position = "left",
  size = 90,
  top = 16,
}: {
  position?: "left" | "right";
  size?: number;
  top?: number;
}) {
  const xClass =
    position === "left" ? "left-3 md:left-6" : "right-3 md:right-6";
  return (
    <div
      className={`pointer-events-none absolute z-0 hidden md:block ${xClass}`}
      style={{ top }}
      aria-hidden
    >
      <svg viewBox="0 0 130 240" width={size} height={size * 1.85} fill="none">
        <path
          d="M65 0 C 70 60, 60 100, 65 140"
          stroke="var(--amber)"
          strokeWidth="2"
          opacity="0.55"
        />
        <path
          d="M65 140 C 35 160, 30 200, 60 225 C 75 230, 95 215, 100 195 C 105 170, 90 145, 65 140 Z"
          fill="var(--amber)"
          opacity="0.85"
        />
      </svg>
    </div>
  );
}
